// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"ee60cc82","235":"62b5287d","292":"4912f548","727":"9515f084","787":"8a1afb32","909":"bc1354fc"}[chunkId] + ".chunk.js";
};